/**
 * @todo Удалить файл если эксперимент не заапрувится
 * @description Данный функционал появился в задаче CD-116486, будет удалён в задаче CD-117944
 */
import { RemoveAllComponentCopiesService } from '../../../../serp/components/offers/CoworkingProfitBanner/internal/services/RemoveAllComponentCopiesService';

export class UserProfilingModalService extends RemoveAllComponentCopiesService {
  private static readonly WAS_USER_PROFILING_MODAL_CLOSED = 'wasUserProfilingModalClosed';

  public static get isUserProfilingModalWasShown(): boolean {
    try {
      const userProflingModalWasShown =
        sessionStorage.getItem(UserProfilingModalService.WAS_USER_PROFILING_MODAL_CLOSED) ?? 'false';

      return JSON.parse(userProflingModalWasShown);
    } catch {
      // Без sessionStorage (поисковый бот, запрет cookie) показ не запомнить,
      // и модалка открывалась бы на каждой странице
      return true;
    }
  }

  public static setUserProfilingModalWasShown(): void {
    if (!UserProfilingModalService.isUserProfilingModalWasShown) {
      try {
        sessionStorage.setItem(UserProfilingModalService.WAS_USER_PROFILING_MODAL_CLOSED, 'true');
      } catch {
        // Квота или запрет хранилища: показ просто не запомнится
      }
    }
  }
}
